import { ThemeConfig } from './types';

export const lightTheme: ThemeConfig = {
  pageBackground: '#f8fafc',
  sidebarBackground: '#ffffff',
  sidebarText: '#64748b',
  sidebarTextHover: '#334155',
  sidebarActive: '#8b5cf6',
  sidebarActiveText: '#ffffff',
  sidebarBorder: 'rgba(0, 0, 0, 0.06)',
  headerBackground: '#ffffff',
  headerText: '#1e293b',
  headerBorder: 'rgba(0, 0, 0, 0.06)',
  headerButtonHover: '#f1f5f9',
  cardBackground: '#ffffff',
  cardText: '#334155',
  cardMuted: '#94a3b8',
  cardBorder: 'rgba(0, 0, 0, 0.06)',
  buttonPrimary: '#8b5cf6',
  buttonPrimaryText: '#ffffff',
  buttonPrimaryHover: '#7c3aed',
  buttonSecondary: '#f1f5f9',
  buttonSecondaryText: '#475569',
  buttonSecondaryHover: '#e2e8f0',
  buttonGhost: 'transparent',
  buttonGhostHover: '#f1f5f9',
  inputBackground: '#ffffff',
  inputText: '#1e293b',
  inputBorder: 'rgba(0, 0, 0, 0.10)',
  inputFocus: '#8b5cf6',
  modalBackground: '#ffffff',
  modalText: '#1e293b',
  modalBorder: '#e5e7eb',
  modalOverlay: 'rgba(0, 0, 0, 0.5)',
  notificationBackground: '#ffffff',
  notificationText: '#1e293b',
  notificationBorder: 'rgba(0, 0, 0, 0.06)',
  errorColor: '#ef4444',
  successColor: '#10b981',
  warningColor: '#f59e0b',
  infoColor: '#3b82f6',
};

export const darkTheme: ThemeConfig = {
  pageBackground: '#050505',
  sidebarBackground: '#0a0a0a',
  sidebarText: '#6b7280',
  sidebarTextHover: '#d1d5db',
  sidebarActive: '#39ff14',
  sidebarActiveText: '#050505',
  sidebarBorder: 'rgba(57, 255, 20, 0.08)',
  headerBackground: '#0a0a0a',
  headerText: '#e5e7eb',
  headerBorder: 'rgba(57, 255, 20, 0.08)',
  headerButtonHover: 'rgba(57, 255, 20, 0.08)',
  cardBackground: '#0f0f0f',
  cardText: '#d1d5db',
  cardMuted: '#6b7280',
  cardBorder: 'rgba(57, 255, 20, 0.08)',
  buttonPrimary: '#39ff14',
  buttonPrimaryText: '#050505',
  buttonPrimaryHover: '#32e612',
  buttonSecondary: 'rgba(57, 255, 20, 0.06)',
  buttonSecondaryText: '#d1d5db',
  buttonSecondaryHover: 'rgba(57, 255, 20, 0.12)',
  buttonGhost: 'transparent',
  buttonGhostHover: 'rgba(57, 255, 20, 0.06)',
  inputBackground: '#0a0a0a',
  inputText: '#e5e7eb',
  inputBorder: 'rgba(57, 255, 20, 0.12)',
  inputFocus: '#39ff14',
  modalBackground: '#0f0f0f',
  modalText: '#e5e7eb',
  modalBorder: 'rgba(57, 255, 20, 0.15)',
  modalOverlay: 'rgba(0, 0, 0, 0.7)',
  notificationBackground: '#0f0f0f',
  notificationText: '#e5e7eb',
  notificationBorder: 'rgba(57, 255, 20, 0.12)',
  errorColor: '#f87171',
  successColor: '#39ff14',
  warningColor: '#fbbf24',
  infoColor: '#60a5fa',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
